import DispensaryProductPage from 'src/dispensary/product';
import { DispensaryProductLayout } from 'src/components/layouts/dispensary-product-layout';

DispensaryProductPage.layout = DispensaryProductLayout;
export default DispensaryProductPage;
